var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "link_off_svg__linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 28,
    y1: 96.4,
    x2: 165.87,
    y2: 96.4,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%,56.470588%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%,83.137255%,94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "link_off_svg__linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 34,
    y1: 96.4,
    x2: 159.87,
    y2: 96.4,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%,56.470588%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%,83.137255%,94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "link_off_svg__linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 262.89,
    y1: 332.48,
    x2: 400.75,
    y2: 332.48,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%,56.470588%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%,83.137255%,94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "link_off_svg__linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 268.89,
    y1: 332.48,
    x2: 394.76,
    y2: 332.48,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%,56.470588%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%,83.137255%,94.901961%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "link_off_svg__surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#link_off_svg__linear0)"
    },
    d: "M 7.140625 12.339844 C 7.007812 12.339844 6.878906 12.308594 6.757812 12.253906 L 2.617188 10.359375 C 2.160156 10.152344 1.957031 9.605469 2.167969 9.148438 C 2.316406 8.824219 2.644531 8.613281 3 8.613281 C 3.132812 8.613281 3.261719 8.640625 3.378906 8.695312 L 7.519531 10.589844 C 7.980469 10.800781 8.179688 11.34375 7.972656 11.804688 C 7.824219 12.128906 7.496094 12.339844 7.140625 12.339844 Z M 9.246094 10.109375 C 9 10.109375 8.769531 10.015625 8.597656 9.84375 L 5.519531 6.765625 C 5.347656 6.59375 5.25 6.363281 5.25 6.117188 C 5.25 5.871094 5.347656 5.644531 5.519531 5.46875 C 5.691406 5.296875 5.921875 5.203125 6.167969 5.203125 C 6.410156 5.203125 6.640625 5.296875 6.8125 5.46875 L 9.890625 8.546875 C 10.25 8.90625 10.25 9.484375 9.890625 9.84375 C 9.71875 10.015625 9.488281 10.109375 9.246094 10.109375 Z M 11.429688 8.03125 C 11.066406 8.03125 10.738281 7.816406 10.589844 7.484375 L 8.75 3.292969 C 8.546875 2.832031 8.757812 2.289062 9.21875 2.085938 C 9.335938 2.035156 9.457031 2.007812 9.585938 2.007812 C 9.949219 2.007812 10.277344 2.222656 10.421875 2.554688 L 12.265625 6.75 C 12.363281 6.972656 12.367188 7.222656 12.28125 7.449219 C 12.191406 7.675781 12.019531 7.855469 11.796875 7.957031 C 11.679688 8.007812 11.554688 8.03125 11.429688 8.03125 Z M 11.429688 8.03125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#link_off_svg__linear1)"
    },
    d: "M 7.335938 10.996094 L 3.195312 9.101562 C 2.957031 8.996094 2.679688 9.097656 2.574219 9.335938 C 2.464844 9.570312 2.566406 9.847656 2.804688 9.957031 L 6.945312 11.851562 C 7.179688 11.957031 7.457031 11.855469 7.566406 11.617188 C 7.675781 11.382812 7.570312 11.105469 7.335938 10.996094 Z M 11.859375 6.929688 L 10.015625 2.738281 C 9.910156 2.5 9.636719 2.390625 9.398438 2.496094 C 9.160156 2.601562 9.054688 2.878906 9.15625 3.113281 L 11 7.304688 C 11.105469 7.542969 11.378906 7.652344 11.617188 7.546875 C 11.855469 7.441406 11.960938 7.164062 11.859375 6.929688 Z M 9.578125 8.863281 L 6.496094 5.785156 C 6.3125 5.601562 6.015625 5.601562 5.835938 5.785156 C 5.652344 5.96875 5.652344 6.265625 5.835938 6.449219 L 8.914062 9.527344 C 9.097656 9.710938 9.394531 9.710938 9.578125 9.527344 C 9.757812 9.34375 9.757812 9.046875 9.578125 8.863281 Z M 9.578125 8.863281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#link_off_svg__linear2)"
    },
    d: "M 22.320312 29.90625 C 21.957031 29.90625 21.628906 29.691406 21.480469 29.359375 L 19.640625 25.167969 C 19.4375 24.703125 19.648438 24.164062 20.109375 23.960938 C 20.226562 23.910156 20.351562 23.882812 20.476562 23.882812 C 20.839844 23.882812 21.167969 24.097656 21.316406 24.429688 L 23.160156 28.621094 C 23.363281 29.085938 23.148438 29.625 22.6875 29.828125 C 22.570312 29.878906 22.449219 29.90625 22.320312 29.90625 Z M 25.742188 26.714844 C 25.496094 26.714844 25.265625 26.617188 25.09375 26.445312 L 22.015625 23.367188 C 21.660156 23.011719 21.660156 22.429688 22.015625 22.074219 C 22.1875 21.902344 22.417969 21.804688 22.664062 21.804688 C 22.90625 21.804688 23.136719 21.902344 23.308594 22.074219 L 26.390625 25.152344 C 26.746094 25.507812 26.746094 26.089844 26.390625 26.445312 C 26.214844 26.617188 25.984375 26.714844 25.742188 26.714844 Z M 28.90625 23.304688 C 28.777344 23.304688 28.648438 23.273438 28.527344 23.21875 L 24.386719 21.324219 C 24.164062 21.222656 23.996094 21.042969 23.910156 20.8125 C 23.824219 20.582031 23.835938 20.335938 23.933594 20.113281 C 24.085938 19.789062 24.410156 19.578125 24.769531 19.578125 C 24.898438 19.578125 25.027344 19.605469 25.148438 19.660156 L 29.289062 21.554688 C 29.746094 21.765625 29.949219 22.3125 29.738281 22.769531 C 29.589844 23.09375 29.265625 23.304688 28.90625 23.304688 Z M 28.90625 23.304688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#link_off_svg__linear3)"
    },
    d: "M 24.574219 20.917969 L 28.714844 22.8125 C 28.949219 22.921875 29.226562 22.816406 29.335938 22.582031 C 29.441406 22.347656 29.339844 22.070312 29.105469 21.960938 L 24.964844 20.066406 C 24.730469 19.960938 24.449219 20.0625 24.34375 20.296875 C 24.234375 20.535156 24.335938 20.8125 24.574219 20.917969 Z M 20.050781 24.988281 L 21.890625 29.179688 C 21.996094 29.417969 22.273438 29.523438 22.507812 29.421875 C 22.746094 29.316406 22.855469 29.039062 22.75 28.804688 L 20.90625 24.609375 C 20.804688 24.375 20.527344 24.265625 20.289062 24.371094 C 20.054688 24.476562 19.945312 24.75 20.050781 24.988281 Z M 22.332031 23.050781 L 25.410156 26.128906 C 25.59375 26.3125 25.890625 26.3125 26.074219 26.128906 C 26.257812 25.949219 26.257812 25.652344 26.074219 25.46875 L 22.996094 22.390625 C 22.8125 22.207031 22.515625 22.207031 22.332031 22.390625 C 22.148438 22.574219 22.148438 22.871094 22.332031 23.050781 Z M 22.332031 23.050781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,96.862745%,96.862745%)",
      fillOpacity: 1
    },
    d: "M 18.539062 21.1875 C 18.292969 21.1875 18.0625 21.28125 17.890625 21.457031 L 13.683594 25.671875 C 13.214844 26.140625 12.667969 26.503906 12.058594 26.75 C 11.464844 26.988281 10.835938 27.109375 10.183594 27.109375 C 8.777344 27.109375 7.441406 26.554688 6.421875 25.546875 L 6.378906 25.503906 C 5.355469 24.480469 4.792969 23.132812 4.792969 21.714844 C 4.792969 21.0625 4.910156 20.429688 5.148438 19.839844 C 5.394531 19.226562 5.753906 18.683594 6.21875 18.214844 L 10.425781 14 C 10.597656 13.824219 10.691406 13.59375 10.691406 13.351562 C 10.691406 13.105469 10.597656 12.875 10.421875 12.703125 C 10.25 12.53125 10.019531 12.4375 9.777344 12.4375 C 9.53125 12.4375 9.300781 12.53125 9.128906 12.707031 L 4.921875 16.921875 C 4.28125 17.566406 3.785156 18.316406 3.449219 19.160156 C 3.125 19.96875 2.960938 20.828125 2.960938 21.714844 C 2.960938 23.625 3.714844 25.429688 5.085938 26.800781 L 5.136719 26.847656 C 6.5 28.199219 8.289062 28.941406 10.179688 28.941406 L 10.183594 28.941406 C 11.070312 28.941406 11.929688 28.773438 12.742188 28.449219 C 13.582031 28.109375 14.335938 27.613281 14.980469 26.96875 L 19.1875 22.75 C 19.542969 22.394531 19.542969 21.8125 19.183594 21.457031 C 19.011719 21.28125 18.78125 21.1875 18.539062 21.1875 Z M 18.539062 21.1875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,96.862745%,96.862745%)",
      fillOpacity: 1
    },
    d: "M 26.886719 5.050781 C 26.886719 5.050781 26.867188 5.027344 26.867188 5.027344 C 25.5 3.664062 23.695312 2.910156 21.792969 2.910156 C 20.90625 2.910156 20.042969 3.074219 19.234375 3.398438 C 18.390625 3.738281 17.636719 4.238281 16.996094 4.882812 L 12.789062 9.097656 C 12.613281 9.273438 12.519531 9.5 12.519531 9.746094 C 12.519531 9.992188 12.617188 10.21875 12.789062 10.390625 C 12.960938 10.566406 13.191406 10.660156 13.433594 10.660156 C 13.679688 10.660156 13.910156 10.566406 14.082031 10.390625 L 18.289062 6.171875 C 18.757812 5.707031 19.304688 5.34375 19.914062 5.097656 C 20.507812 4.859375 21.140625 4.738281 21.792969 4.738281 C 23.207031 4.738281 24.550781 5.300781 25.570312 6.320312 L 25.59375 6.34375 C 26.617188 7.367188 27.183594 8.714844 27.183594 10.132812 C 27.183594 10.785156 27.0625 11.417969 26.824219 12.007812 C 26.582031 12.621094 26.21875 13.167969 25.753906 13.632812 L 21.546875 17.851562 C 21.191406 18.207031 21.191406 18.789062 21.546875 19.144531 C 21.722656 19.316406 21.953125 19.410156 22.195312 19.410156 C 22.4375 19.410156 22.671875 19.316406 22.84375 19.144531 L 27.050781 14.925781 C 27.691406 14.28125 28.1875 13.53125 28.523438 12.6875 C 28.847656 11.878906 29.011719 11.019531 29.011719 10.132812 C 29.011719 8.226562 28.257812 6.417969 26.886719 5.046875 Z M 26.886719 5.050781 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkOff);
export default __webpack_public_path__ + "static/media/link_off.cbfa56700bd10f24af0108ce9ea45582.svg";
export { ForwardRef as ReactComponent };